<template>
  <SimpleDataTable
      :clickable-title="true"
      :title="'Satış İrsaliyesi Raporu'"
      :description="''"
      :dataList="saleWaybillReportData"
      :dataHeaders="saleWaybillReportHeaders"
      :loading="saleWaybillReportDataLoading"
  >
    <template v-slot:filterAndAction>
      <v-select
          v-model="saleWaybillReportTimePeriodFilterValue"
          :items="[
                      {value: 5, text: 'Tarih Aralığı'},
                      {value: 4, text: 'Yıllık'},
                      {value: 3, text: 'Aylık'},
                      {value: 2, text: 'Haftalık'},
                      {value: 1, text: 'Günlük'}
                  ]"
          style="width:100px;margin: 0 3px"
          label=""
          item-text="text"
          item-value="value"
          filled
          solo
          hide-details
          dense
          @change="saleWaybillReportTimePeriodFilterValue !== 5  ? _fetchSaleWaybillReport : null"
      >

      </v-select>
      <div v-if="saleWaybillReportTimePeriodFilterValue === 5">
        <v-menu
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="formattedDate(saleWaybillReportDateRangeStartFilterValue)"
                placeholder="Filtre Başlangıç Tarihi"
                class="m-1"
                readonly
                filled
                solo
                dense
                clearable
                @click:clear="saleWaybillReportDateRangeStartFilterValue = null"
                hide-details
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="saleWaybillReportDateRangeStartFilterValue"
              locale="tr"
              :max="saleWaybillReportDateRangeEndFilterValue ? saleWaybillReportDateRangeEndFilterValue : 'NaN-Nan-Nan'"
          ></v-date-picker>
        </v-menu>
        <v-menu
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="formattedDate(saleWaybillReportDateRangeEndFilterValue)"
                placeholder="Filtre Bitiş Tarihi"
                readonly
                solo
                filled
                class="m-1"
                dense
                clearable
                @click:clear="saleWaybillReportDateRangeEndFilterValue = null"
                hide-details
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="saleWaybillReportDateRangeEndFilterValue"
              locale="tr"
              :min="saleWaybillReportDateRangeStartFilterValue"
          ></v-date-picker>
        </v-menu>
        <div class="w-100 text-center">
          <v-btn
              x-small
              class="mx-auto"
              color="primary darken-2"
              @click="_fetchSaleWaybillReport"
          >
            FİLTRELE
          </v-btn>
        </div>
      </div>
    </template>
  </SimpleDataTable>
</template>

<script>

import SimpleDataTable from "@/components/dashboard/SimpleDataTable";
import {mapActions, mapState} from "vuex";
import {formattedDate} from "@/momentHelper";
import {numberConverter} from "../../../../helpers";

export default {
  name: "SatisIrsaliyesiRaporu",
  components: {
    SimpleDataTable
  },
  props:{
    dashboardFilterCurrentCodeProp: {
      type: String,
      default: null
    },
    dashboardFilterSalesPersonCodeProp: {
      type: String,
      default: null
    },
    dashboardFilterReportDbNameProp: {
      type: String,
      default: null
    }
  },
  computed:{
    ...mapState("settings", ["erpSettings"]),
    ...mapState("auth",["user"])
  },
  mounted(){
    this._fetchSaleWaybillReport()
  },
  data(){
    return {
      saleWaybillReportHeaders:[],
      saleWaybillReportData:[],
      saleWaybillReportDataLoading: false,
      saleWaybillReportTimePeriodFilterValue: 4,
      saleWaybillReportDateRangeStartFilterValue: null,
      saleWaybillReportDateRangeEndFilterValue: null,
    }
  },
  methods: {
    formattedDate,
    numberConverter,
    ...mapActions("dashboard",["fetchSaleReport","fetchCurrencySaleReport"]),
    _fetchSaleWaybillReport(){

      this.saleWaybillReportDataLoading = true;

      const requestData = {
        params: {
          userId: this.user.UserId,
        },
        body: {
          ...(!(this.dashboardFilterCurrentCodeProp === "" || this.dashboardFilterCurrentCodeProp == null)) && {currentCode: this.dashboardFilterCurrentCodeProp},
          ...(!(this.dashboardFilterSalesPersonCodeProp === "" || this.dashboardFilterSalesPersonCodeProp == null)) && {salesPersonCode: this.dashboardFilterSalesPersonCodeProp},
          ...(!(this.dashboardFilterReportDbNameProp === "" || this.dashboardFilterReportDbNameProp == null)) && {reportDbName: this.dashboardFilterReportDbNameProp},
          ...(!(this.saleWaybillReportTimePeriodFilterValue === "" || this.saleWaybillReportTimePeriodFilterValue == null)) && {DateType: this.saleWaybillReportTimePeriodFilterValue},
          Type: 3
        },
      };

      if (this.saleWaybillReportTimePeriodFilterValue === 5) {
        requestData.body.startDate = this.saleWaybillReportDateRangeStartFilterValue;
        requestData.body.endDate = this.saleWaybillReportDateRangeEndFilterValue;
      }

      this.fetchSaleReport(requestData).then(async (result) => {
        if(result && result.data.success)
        {
          this.saleWaybillReportData = [];
          this.saleWaybillReportData.push(result.data.data);
          this.saleWaybillReportData.map(item => item.vatExcludedAmount = this.numberConverter(item.vatExcludedAmount))
          this.saleWaybillReportData.map(item => item.vatExcludedCurrencyAmount = this.numberConverter(item.vatExcludedCurrencyAmount))
          this.saleWaybillReportHeaders = [
            {
              key: 'vatExcludedAmount',
              label: 'Tutar (TL)',
              sortable: false,
            },
          ]
          if (this.erpSettings.netsisCurrencySale) {
            await this.fetchCurrencySaleReport(requestData).then(async (result) => {
              if (!result) {
                this.purchaseReportDataLoading = false;
                return;
              }
              result.data.data.map((item) => {
                this.saleWaybillReportHeaders.push({
                  key: item.currencyName,
                  label: item.currencySymbol,
                  sortable: false,
                  class: 'text-center pe-4'
                })
                let keytemp = `${item.currencyName}`;
                item[keytemp] = item.vatExcludedAmount;
                delete item.vatExcludedAmount;
                let existingItem = this.saleWaybillReportData[0];
                if (existingItem) {
                  existingItem[item.currencyName] = this.numberConverter(item[keytemp]);
                } else {
                  let newObj = {
                    [item.currencyName]: item[keytemp]
                  };
                  this.saleWaybillReportData.push(newObj);
                }
              });
              this.saleWaybillReportData.push(result.data.data);
            })
          }
        }

        this.saleWaybillReportDataLoading = false;
      })
    },
  },
  watch: {
    dashboardFilterCurrentCodeProp(newVal){
      newVal;
      this._fetchSaleWaybillReport()
    },
    dashboardFilterSalesPersonCodeProp(newVal){
      newVal;
      this._fetchSaleWaybillReport()
    },
    dashboardFilterReportDbNameProp(newVal){
      newVal;
      this._fetchSaleWaybillReport()
    },
    saleWaybillReportTimePeriodFilterValue(newVal){
      if (newVal === 5) return;
      this._fetchSaleWaybillReport()
    },
  }
}
</script>

<style scoped>

</style>